// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"300":"5be960b681e713ae","521":"17f8286fdb626034"}[chunkId] + ".js";
};